import FieldPopover from "../../popover/popover"
import FieldConfig from "../../../proto/field-config"
import FieldTimeOfDay_View from "./render/view"
import formatTime from "../../../../gd/format/time"
import FieldTimeOfDay_GListEditable from "./render/glist-editable"
import FieldTimeOfDay_ListValueNotEmpty from "./components/list-value/list-value-not-empty"
import FieldTimeOfDay_ListValueEmpty from "./components/list-value/list-value-empty"
import FieldTimeOfDay_PopoverMenu from "./components/popover/popover-menu"
import FieldDropdown_PopoverOption from "../../dropdown/components/option/option"
import {roundTo15MinutesDown} from "../../../../gd/utils/datetime/round-to-15-minutes-down"
import FieldTimeOfDay_InlineEditable from "./render/inline-editable"
import FieldTimeOfDay_FormElementView from "./render/form-element-view"
import FieldTimeOfDay_FormValueEmpty from "./components/form/value-empty"
import FieldTimeOfDay_FormValueNotEmpty from "./components/form/value-not-empty"
import FieldTimeOfDay_FormElement from "./render/form-element"
import FieldPopover_InlineValueNotEmptyV2 from "../../popover/components/inline/value-not-empty-v2"
import CustomFieldsV1 from "../../../../gd/const/fields/custom-fields-v1"
import {GROUP_DATE_TIME} from "../../../../gd/const/fields/field2-groups"
import SessionCustomField from "../../../../model2/custom-field/session-custom-field"
import {FieldType} from "../../../field-type"
import FieldTimeOfDay_ManagementFormCFV1 from "./render/management/management-form-cfv1"
import FieldTimeOfDay_Editable from "./render/editable/editable"
import FieldTimeOfDay_ManagementPreview from "./render/management/management-preview"
import AggregateMoment from "../../../../fields/aggregate/aggregate-moment"
import AggregateMomentTimeComponent from "../../../../fields/system/components/aggregate-moment-time"
import FieldTimeOfDay_ManagementForm from "./render/management/management-form"
import DatetimeUtils from "../../../../gd/utils/datetime-utils"
import FieldTimeOfDay_ViewProperty from "./render/property"
import {AggregateFunctionType} from "../../../../data-structures/aggregators/types"
import FieldTimeOfDay_TableCellCalculated from "./render/table/table-cell-calculated"
import FieldTimeOfDay_AggregateCell from "./render/aggregate/aggregate-cell"
import FieldTimeOfDay_BoardAggregate from "./render/aggregate/board-aggregate"

// IN DB - both date and time

export default class FieldTimeOfDay extends FieldPopover {

    public scrollToSelected     : boolean   = true      // auto scroll to time option in popover

    constructor(config:FieldConfig) {
        super(config);

        this.typeInteger        = CustomFieldsV1.type.TIME_OF_DAY
        this.typeLabel          = "Time of Day"
        this.typeDescription    = "Generic time picker field";
        this.icon               = 'i5-my-time'
        this.clearButton        = true
        this.typeGroup          = GROUP_DATE_TIME

        // INIT OPTION
        this.options            = []
        const timeStep     = 15

        const startMoment = moment().startOf('day')
        // 24 hours is 96 steps of 15 minutes (this.props.timeStep)
        const steps = Math.floor(24 * 60 / timeStep);

        for (let i = 0; i < steps; i++) {
            const option = moment(startMoment).add(timeStep * i, 'minutes');

            this.options.push({
                label   : formatTime(option),
                value   : {hours: option.hours(), minutes: option.minutes()}
            })
        }
        // End INIT OPTIONS

        // if true will add no value option to options list (by default true for custom fields)
        this.noValueOption          = _.get(config,'noValueOption',false)
        this.noValueOptionLabel     = _.get(config,'noValueOptionLabel','Not specified')

        // default placeholder for FORM element
        this.placeholder            = _.get(config,'placeholder','Please select')

        // this.showMenuMore       = false
        this.isSearchable           = true
        this.isFilterAvailable      = false
        // this.scrollToSelected       = true

        this.hasCalculatedValues    = true

        this.classes    = {
            PopoverMenu                 : '', // to add classes for popover menu shell
            PopoverMenuScrollContainer  : 'max-h-200', // to add classes for popover menu scroll container (max-h-200 for example)
        }

        // Components & Render
        this.components.PopoverMenuMore             = null
        this.components.InlineValueNotEmpty         = FieldPopover_InlineValueNotEmptyV2
        this.components.ListValueEmpty              = FieldTimeOfDay_ListValueEmpty
        this.components.ListValueNotEmpty           = FieldTimeOfDay_ListValueNotEmpty
        this.components.FormValueEmpty              = FieldTimeOfDay_FormValueEmpty
        this.components.FormValueNotEmpty           = FieldTimeOfDay_FormValueNotEmpty
        this.components.PopoverMenu                 = FieldTimeOfDay_PopoverMenu
        this.components.PopoverOption               = FieldDropdown_PopoverOption

        // Render Components
        this.renderComponents.editable              = FieldTimeOfDay_Editable
        this.renderComponents.inlineEditable        = FieldTimeOfDay_InlineEditable
        this.renderComponents.glistEditable         = FieldTimeOfDay_GListEditable
        this.renderComponents.formElement           = FieldTimeOfDay_FormElement
        this.renderComponents.formElementView       = FieldTimeOfDay_FormElementView
        this.renderComponents.view                  = FieldTimeOfDay_View
        this.renderComponents.viewProperty          = FieldTimeOfDay_ViewProperty
        this.renderComponents.managementPreview     = FieldTimeOfDay_ManagementPreview
        this.renderComponents.managementForm        = FieldTimeOfDay_ManagementForm
        this.renderComponents.managementFormCFV1    = FieldTimeOfDay_ManagementFormCFV1

        this.renderComponents.tableCellCalculated   = FieldTimeOfDay_TableCellCalculated
        this.renderComponents.aggregateCell         = FieldTimeOfDay_AggregateCell
        this.renderComponents.boardAggregate        = FieldTimeOfDay_BoardAggregate
    }

    static initFromCustomFieldV1(customFieldV1:SessionCustomField) {
        return new FieldTimeOfDay({
            fieldId         : customFieldV1.id,
            type            : FieldType.TIME_OF_DAY,
            fieldParams     : customFieldV1.params,
            fieldAccess     : customFieldV1.access
        })
    }

    _getOption(value:any) {

        if (this.hasOptionWithNullValue || !_.isNil(value)) {
            const option = _.find(this.getOptions(), option => _.isEqual(option.value,  value))
            if (option) return option
        }

        return false
    }

    getViewValue(model: any){
        const viewValue = _.get(model, this.fieldId, null)

        if(viewValue){
            return moment(viewValue)
        }
        else{
            return viewValue
        }
    }

    getDisplayValue(value: any): any {

        if (!value) return value

        return formatTime(value)
    }

    getCsvValue(value:any) {

        const viewValue = this.getViewValue(value)

        return this.getDisplayValue(viewValue)
    }

    sortValue(value: any, model?: any) {
        return value ? DatetimeUtils.datetimeToMoment(value).format('x') : 0;
    }

    getMatchingOption(model:any, options?: any):Option {
        let timeValue: any = null

        let value = this.getViewValue(model)
        if (!value && options?.isMandatory) value = moment()

        if (options?.closestMatch) {
            timeValue   = roundTo15MinutesDown(value.hours(), value.minutes())
        } else { // exact
            timeValue   = {
                hours   : value?.hours(),
                minutes : value?.minutes()
            }
        }

        return _.find(this.options, (option)=>
            option.value.hours      === timeValue?.hours &&
            option.value.minutes    === timeValue?.minutes
        )
    }

    groupValue(value:any) {
        return _.get(this._getOption(value),'value', null)
    }

    groupSortValue(value:any) {
        return _.indexOf(this.options, this._getOption(value))
    }

    get AggregateComponent() {return AggregateMomentTimeComponent.bind(null, this.getAggregateOptions())}

    getAggregateClass() {
        return AggregateMoment
    }

    getAggregateOptions() {return [
        AggregateFunctionType.DATE_MIN,
        AggregateFunctionType.DATE_MAX,
        AggregateFunctionType.DATE_RANGE,
    ]}
}
